import script from "./NewProgramInSpireStep5View.vue?vue&type=script&setup=true&lang=js"
export * from "./NewProgramInSpireStep5View.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__